export default "__VITE_ASSET__BIHw1bqn__"